export function InViewOnce(rootDom) {
    const options = {
        rootMargin: '0% 0% -10% 0%',
        threshold: 0,
    };
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting && document.documentElement.classList.contains('_preloaded')) {
                entry.target.dataset.inViewOnce = true;
                observer.unobserve(rootDom);
            }
        });
    };
    const observer = new IntersectionObserver(callback, options);

    observer.observe(rootDom);
}

// Если страница еще не загружена и не отработала анимация прелоадера html._preloaded, то ждем
function init() {
    if (document.documentElement.classList.contains('_preloaded')) {
        document.querySelectorAll('[data-in-view-once]').forEach(InViewOnce);
        return;
    }

    const observer = new MutationObserver(mutations => {
        const isPreloaded = mutations.some(mutation => {
            return mutation.type === 'attributes'
                && mutation.attributeName === 'class'
                && mutation.target.classList.contains('_preloaded');
        });

        if (isPreloaded) {
            observer.disconnect();

            // Ждем анимацию шторки
            setTimeout(() => {
                document.querySelectorAll('[data-in-view-once]').forEach(InViewOnce);
            }, 500);
        }
    });

    // Отслеживаем добавление класса _preloaded
    observer.observe(document.documentElement, { attributes: true });
}

App.W.on("barba:afterEnter", init);



// WEBPACK FOOTER //
// ./_src/js/modules/InViewOnce.js